export const VENTS = [{ x: 140, y: 34 }, { x: 780, y: 34 }];
const VENT_W = 40;

export const spawnPuff = (puffs, strength) => {
  const v = VENTS[Math.floor(Math.random() * VENTS.length)];
  puffs.push({
    x: v.x + VENT_W / 2 + (Math.random() - 0.5) * 20,
    y: v.y + 8,
    vx: (Math.random() - 0.5) * 1.4,
    vy: 0.4 + Math.random() * 2.4 * strength,
    r: 8 + Math.random() * 8,
    grow: 0.25 + Math.random() * 0.45 * strength,
    a: 0.07 + 0.1 * strength,
    life: 1,
  });
};

export const updatePuffs = (puffs) => {
  for (const p of puffs) {
    p.x += p.vx;
    p.y += p.vy;
    p.vy *= 0.992;
    p.r += p.grow;
    p.life -= 0.004;
  }
  return puffs.filter((p) => p.life > 0 && p.r < 280);
};

export const drawVents = (ctx, active) => {
  for (const v of VENTS) {
    ctx.fillStyle = "#15171d";
    ctx.fillRect(v.x - 3, v.y - 3, VENT_W + 6, 16);
    ctx.fillStyle = "#050608";
    ctx.fillRect(v.x, v.y, VENT_W, 10);
    ctx.fillStyle = active ? "rgba(128,140,96,0.5)" : "#22262f";
    for (let i = 0; i < 4; i++) ctx.fillRect(v.x + 2, v.y + 1 + i * 2.5, VENT_W - 4, 1);
  }
};

export const drawPuffs = (ctx, puffs) => {
  for (const p of puffs) {
    const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
    g.addColorStop(0, `rgba(128,140,96,${p.a * p.life})`);
    g.addColorStop(1, "rgba(128,140,96,0)");
    ctx.fillStyle = g;
    ctx.fillRect(p.x - p.r, p.y - p.r, p.r * 2, p.r * 2);
  }
};
